export default __webpack_public_path__ + "static/media/matplotlib.f56b8058.png";